import ChainedSelect from './chained-select';

export default {
  init: function (selector) {
    const chainedSelects = document.querySelectorAll(selector);

    if (chainedSelects && chainedSelects.length) {
      [...chainedSelects].map(item => {
        const chainedSelect = new ChainedSelect(item);
        chainedSelect.init();
      });
    }
  }
};
